import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {VehicleType} from "../../types/vehicle.type";
import {CommonsService} from "../../services/commons-service.service";

export class VehicleClassMultiSelectListComponent implements IController {
  vehicleTypes: VehicleType[];
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;
  public isSelectAll: boolean;

  constructor(private commonsService: CommonsService) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = Object.values(VehicleType);
    }
  }

  $onChanges(changes) {
    if (changes.vehicleTypes) {
      this.selectedKeys = [];
      _.forEach(this.vehicleTypes, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      vehicleTypes: isSelected ? _.concat(this.vehicleTypes, [option]) :
        _.filter(this.vehicleTypes, (type) => {
          return type !== option;
        })
    });
  }


  submitQuery(query) {
    this.queryString = query;
  }

  onReset() {
    this.onChange({vehicleTypes: []});
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onReset();
    } else {
      this.onChange({vehicleTypes: this.options || []});
    }
  }


  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.options, this.vehicleTypes);
    return this.isSelectAll;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('vehicleClassMultiSelectList', {
    bindings: {
      vehicleTypes: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./vehicle-class-multi-select-list.html').default,
    controller: VehicleClassMultiSelectListComponent
  });

